// NPM Imports
import React, { Fragment } from "react";
import Modal from "react-responsive-modal";
import { useSelector } from "react-redux";
import { Button } from "@revvsales/components";

// Comonents Imports

// Internal Imports

import documentSentConfirmation from "../../assets/document-sent-confirmation.png";

export default function AppUpdateNotification() {
  // * MAP STATE TO PROPS SYNTAX IN HOOKS
  const store = useSelector(state => {
    const {
      appVersion: { newVersionFound, isMajorRelease },
    } = state.CommonStore;
    return {
      newVersionFound,
      isMajorRelease,
    };
  });

  if (store.newVersionFound) {
    // * IF ITS A MAJOR RELEASE
    if (store.isMajorRelease) {
      return (
        <Modal
          open
          onClose={() => undefined}
          center
          closeOnEsc={false}
          closeOnOverlayClick={false}
          showCloseIcon={false}>
          <div className="app-update-notification-container">
            <div className="app-update-notification-image">
              <div className="app-update-notification-text">
                <div className="app-update-notification-title">
                  Revv just got better!
                </div>
                <div className="app-update-notification-subtitle">
                  Please refresh to continue
                </div>
              </div>
              <img
                src={documentSentConfirmation}
                alt="Revv"
                className="app-update-notification-confirmation-image"
              />
            </div>
            <div className="app-update-notification-update-txt">
              We’ve updated our app to give you a faster, more efficient
              experience. Please refresh the page to get the latest version. You
              will not be able to use the app until you refresh.
            </div>
            <Button
              onClick={() => window.location.reload()}
              data-test="appupdatenotification-refresh-btn">
              Refresh
            </Button>
          </div>
        </Modal>
      );
    }

    // * IF ITS A MINOR OR A PATCH RELEASE & UPDATE NOTIFICATION DOESN'T EXISTS IN UI
    if (!document.getElementsByClassName("app-update-notification").length) {
      const notify = document.createElement("div");
      notify.classList.add("app-update-notification");
      notify.innerHTML =
        "A new version is available" +
        "<a href='#' class='refresh-btn'>Refresh</a>";

      notify.addEventListener("click", e => {
        e.preventDefault();
        window.location.reload();
      });
      document.querySelector("body").appendChild(notify);
      return true;
    }
  }

  return <Fragment />;
}



// WEBPACK FOOTER //
// ./src/components/AppUpdateNotification/index.js